import React from "react";
import CircleDotSpinner from "../../../common/CircleDotSpinner";
import { Modal } from "react-bootstrap";
// import { PushNotification } from "../../../common/PushNotification";
import commonActions from '../../../../redux/Common/actions'
import { useDispatch } from "react-redux";

export default function IntimateToCustomerForCancel(props) {
    const dispatch = useDispatch()

    const { showIntimateToCustomerForCancelPopup, handleCloseIntimateToCustomerPopup, loader,
        handleIntimateToCustomerForCancel, UserDetails } = props;

    const handleUpdate = (e) => {
        e.preventDefault();
        if (UserDetails?.Notification === 'y' && UserDetails.Notification_Id) {
            let pushMessageData = {
                type: 'customer',
                registration_ids: [UserDetails.Notification_Id],
                title: 'Cakey',
                body: `Refund Against your Cancelled Order is Processed and the full Order Value will be Credited in your Account in 2-3 Working Days`,
            }

            //New Push notification  
            dispatch({ type: commonActions.SEND_PUSH_NOTIFICATION, payload: pushMessageData })

            //old push notification

            // PushNotification(pushMessageData);
        };
        handleIntimateToCustomerForCancel(UserDetails?.UserName);
    };

    return (
        <div>
            <Modal show={showIntimateToCustomerForCancelPopup} onHide={handleCloseIntimateToCustomerPopup} aria-labelledby="contained-modal-title-vcenter"
                centered contentClassName="modal-body-scrollar">
                <Modal.Body className="tabledata-background modal-body-content">
                    <button type="button" className="close change-password-close" onClick={handleCloseIntimateToCustomerPopup}><span aria-hidden="true">×</span></button>
                    <h4 className="text-center pb-2">Confirmation</h4>
                    <div>
                        <h6 className='text-center'>Are you sure you want to intimate to Customer?</h6>
                    </div>
                    {loader ?
                        <div className="login-spinner2"><CircleDotSpinner /></div> :
                        <div className="text-center">
                            <button
                                type="submit"
                                className="btn btn-primary shadow-none mr-3"
                                onClick={handleUpdate}
                            >
                                Yes
                            </button>
                            <button
                                type="submit"
                                className="btn btn-secondary shadow-none"
                                onClick={handleCloseIntimateToCustomerPopup}
                            >
                                No
                            </button>
                        </div>
                    }
                </Modal.Body>
            </Modal>
        </div>
    )
};